export default "__VITE_ASSET__jkgFHeRt__"